<template>
    <div
      @click="toggleAccordion()"
      :class="{
        'by-accordion-light': theme === 'light',
        'by-acccordion-dark': theme === 'dark'
      }">
      <div v-if="isAccordionToggled()">
        {{ $t('message.metadata.showLess') }}
        <svg class="by-accordion-icon by-accordion-icon-caret-up" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <title id="caret-up-title">Caret Up</title>
          <g id="CaretUp">
          <path id="Vector" d="M3.96932 14.4694L11.4693 6.96938C11.539 6.89965 11.6217 6.84433 11.7127 6.80659C11.8038 6.76885 11.9014 6.74942 12 6.74942C12.0985 6.74942 12.1961 6.76885 12.2872 6.80659C12.3782 6.84433 12.4609 6.89965 12.5306 6.96938L20.0306 14.4694C20.1713 14.6101 20.2504 14.801 20.2504 15C20.2504 15.199 20.1713 15.3899 20.0306 15.5306C19.8898 15.6714 19.699 15.7504 19.4999 15.7504C19.3009 15.7504 19.1101 15.6714 18.9693 15.5306L12 8.56032L5.03057 15.5306C4.96089 15.6003 4.87817 15.6556 4.78712 15.6933C4.69608 15.731 4.59849 15.7504 4.49995 15.7504C4.4014 15.7504 4.30382 15.731 4.21278 15.6933C4.12173 15.6556 4.03901 15.6003 3.96932 15.5306C3.89964 15.461 3.84437 15.3782 3.80665 15.2872C3.76894 15.1961 3.74953 15.0986 3.74953 15C3.74953 14.9015 3.76894 14.8039 3.80665 14.7128C3.84437 14.6218 3.89964 14.5391 3.96932 14.4694Z" fill="currentColor"/>
          </g>
        </svg>
      </div>
      <div v-else>
        {{ $t('message.metadata.showMore') }}
        <svg class="by-accordion-icon by-accordion-icon-caret-down" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <title id="caret-down-title">Caret Down</title>
          <g id="CaretDown">
          <path id="Vector" d="M20.0307 9.53062L12.5307 17.0306C12.461 17.1003 12.3783 17.1557 12.2873 17.1934C12.1962 17.2312 12.0986 17.2506 12.0001 17.2506C11.9015 17.2506 11.8039 17.2312 11.7128 17.1934C11.6218 17.1557 11.5391 17.1003 11.4694 17.0306L3.96943 9.53062C3.8287 9.38988 3.74963 9.19901 3.74963 8.99999C3.74963 8.80097 3.8287 8.61009 3.96943 8.46936C4.11016 8.32863 4.30103 8.24957 4.50005 8.24957C4.69907 8.24957 4.88995 8.32863 5.03068 8.46936L12.0001 15.4397L18.9694 8.46936C19.0391 8.39968 19.1218 8.34441 19.2129 8.30669C19.3039 8.26898 19.4015 8.24957 19.5001 8.24957C19.5986 8.24957 19.6962 8.26898 19.7872 8.30669C19.8783 8.34441 19.961 8.39968 20.0307 8.46936C20.1004 8.53905 20.1556 8.62177 20.1933 8.71282C20.2311 8.80386 20.2505 8.90144 20.2505 8.99999C20.2505 9.09854 20.2311 9.19612 20.1933 9.28716C20.1556 9.37821 20.1004 9.46093 20.0307 9.53062Z" fill="currentColor"/>
          </g>
        </svg>
      </div>
    </div>
  </template>

  <script>
  export default {
    name: "Accordion",
    props: [
      'theme',
      'toggleAccordion',
      'isAccordionToggled',
    ]
  }
  </script>

  <style scoped>
    /* specified in styles/by/_bayern-accordion.scss */
  </style>


